import React from 'react';
import { Wallet, UserPlus, Users, Check, X } from 'lucide-react';

const RoyaltyRequirements = ({ requirements }) => {
  const requirementsList = [
    {
      id: 'reqInvestment',
      icon: <Wallet size={18} />,
      title: 'Minimum Investment',
      description: 'Invest at least $100 worth of USDT',
      met: requirements.minInvestmentMet
    },
    {
      id: 'reqDirectRefs',
      icon: <UserPlus size={18} />,
      title: 'Direct Referrals',
      description: 'Have at least 2 direct referrals',
      met: requirements.minReferralsMet
    },
    {
      id: 'reqQualifiedRefs',
      icon: <Users size={18} />,
      title: 'Qualified Referrals',
      description: 'At least 2 direct referrals must have invested $100+',
      met: requirements.qualifiedRefsMet
    }
  ];

  return (
    <div className="royalty-requirements">
      <h2>Royalty Pool Requirements</h2>
      <div className="requirements-grid">
        {requirementsList.map((req) => (
          <div 
            key={req.id} 
            className="requirement-card"
            style={{ borderColor: req.met ? 'var(--primary-color)' : 'var(--tertiary-color)' }}
          >
            <div className="requirement-icon">{req.icon}</div>
            <div className="requirement-content">
              <h3>{req.title}</h3>
              <p>{req.description}</p>
            </div>
            <div className="requirement-status">
              {req.met ? <Check color="var(--primary-color)" /> : <X color="var(--tertiary-color)" />}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoyaltyRequirements;
